window._ = require('lodash');

try {
	window.bootstrap = require('bootstrap');
} catch (e) { }

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import {createApp} from 'vue';
import BlogIndex from "./components/BlogIndex";

const app = createApp({});
app.component('blog-index', BlogIndex);
app.mount('#app');

require('./property-estate-offers');

// Get the current breakpoint
var getBreakpoint = function() {
	return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '');
};

// Calculate breakpoint on page load
let breakpoint = getBreakpoint();



const offeringsMenu = document.querySelector('.offerings-menu');
const teamMenu = document.querySelector('.team-menu');
const offeringsDropdown = document.querySelector('#offeringsMenu');
const teamDropdown = document.querySelector('#teamMenu');

// positioning Submenu on Desktop
function positionSubmenu() {

	// position navbar dropdown :after elements


	function getOffset(el) {
		var _x = 0;
		while (el && !isNaN(el.offsetLeft)) {
			_x += el.offsetLeft - el.scrollLeft;
			el = el.offsetParent;
		}
		return { left: _x };
	}

	function positionDropdown() {
		var offsetOfferingsDropdown = getOffset(document.querySelector("#offeringsMenu")).left;
		offeringsMenu.style.marginLeft = '-' + offsetOfferingsDropdown + 'px';
		var offsetTeamDropdown = getOffset(document.querySelector("#teamMenu")).left;
		teamMenu.style.marginLeft = '-' + offsetTeamDropdown + 'px';
	}

	positionDropdown();

}

window.addEventListener('load', positionSubmenu);

// Recalculate breakpoint on resize

window.addEventListener('resize', function() {
	breakpoint = getBreakpoint();
	if (breakpoint === 'mobile') {
		document.querySelector('.offerings-menu').style.marginLeft = '0';
		document.querySelector('.team-menu').style.marginLeft = '0';
	}
	if (breakpoint === 'desktop') {
		positionSubmenu();

		offeringsDropdown.addEventListener('shown.bs.dropdown', function() {
			window.addEventListener('resize', positionDropdown);
		})
		offeringsDropdown.addEventListener('hidden.bs.dropdown', function() {
			window.removeEventListener('resize', positionDropdown);
		})
		teamDropdown.addEventListener('shown.bs.dropdown', function() {
			window.addEventListener('resize', positionDropdown);
		})
		teamDropdown.addEventListener('hidden.bs.dropdown', function() {
			window.removeEventListener('resize', positionDropdown);
		})
	}
}, false);

// match heights

function setHeight(el, val) {
	if (typeof val === "function") val = val();
	if (typeof val === "string") el.style.height = val;
	else el.style.height = val + "px";
}

var equalheight = function(container) {
	var currentTallest = 0,
		currentRowStart = 0,
		rowDivs = new Array(),
		$el,
		topPosition = 0;

	Array.from(document.querySelectorAll(container)).forEach((el, i) => {
		el.style.height = "auto";
		topPostion = el.offsetTop;
		if (currentRowStart != topPostion) {
			for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
				setHeight(rowDivs[currentDiv], currentTallest)
			}
			rowDivs.length = 0;
			currentRowStart = topPostion;
			currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
			rowDivs.push(el);
		} else {
			rowDivs.push(el);
			currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
		}
		for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
			setHeight(rowDivs[currentDiv], currentTallest)
		}
	})
}

// match object cards inner height

window.addEventListener("load", function() {
	equalheight('.match-tile-height')
})
window.addEventListener("resize", function() {
	setTimeout(function() {
		equalheight('.match-tile--height')
	})
})
